import { defineMessages } from 'react-intl';

const messages = defineMessages({
  scholarshipsTitle: {
    id: 'scholarships.heading.title',
    defaultMessage: 'Scholarships',
  },
  scholarshipsSubText: {
    id: 'scholarships.heading.sub-text',
    defaultMessage: 'Scholarships will be presented to students who fit the requirements. They will also display on your institution\'s profile page for all students in the selected audience.',
  },
  meritScholarshipsTitle: {
    id: 'scholarships.merit-scholarships.title',
    defaultMessage: 'Merit Scholarships',
  },
  meritScholarshipsSubText: {
    id: 'scholarships.merit-scholarships.sub-text',
    defaultMessage: 'Add your institution\'s auto-considered, merit-based scholarships for high school students who could be eligible to receive aid.',
  },
  meritScholarshipsGeneralInfoSubTitle: {
    id: 'scholarships.merit-scholarships.general-info-sub-title',
    defaultMessage: 'General Merit Scholarship Information',
  },
  meritScholarshipsGeneralInfoUrlLabel: {
    id: 'scholarships.merit-scholarships.general-info-url-label',
    defaultMessage: 'Scholarship URL',
  },
  meritScholarshipsGeneralInfoUrlPlaceholder: {
    id: 'scholarships.merit-scholarships.general-info-url-placeholder',
    defaultMessage: 'Enter a link to your institution\'s scholarship page',
  },
  meritScholarshipsGeneralInfoAdditionalInfoLabel: {
    id: 'scholarships.merit-scholarships.general-info-additional-info-label',
    defaultMessage: 'Additional Info',
  },
  meritScholarshipsGeneralInfoAdditionalInfoPlaceholder: {
    id: 'scholarships.merit-scholarships.general-info-additional-info-placeholder',
    defaultMessage: 'Enter general information students should know about your scholarships',
  },
  meritScholarshipsScholarshipNameLabel: {
    id: 'scholarships.merit-scholarships.scholarship-name-label',
    defaultMessage: 'Scholarship Name',
  },
  meritScholarshipsScholarshipNamePlaceholder: {
    id: 'scholarships.merit-scholarships.scholarship-name-placeholder',
    defaultMessage: 'Enter the scholarship name',
  },
  meritScholarshipsAwardAmountLabel: {
    id: 'scholarships.merit-scholarships.award-amount-label',
    defaultMessage: 'Award Amount',
  },
  meritScholarshipsAwardAmountPlaceholder: {
    id: 'scholarships.merit-scholarships.award-type-placeholder',
    defaultMessage: 'Select the type of award',
  },
  meritScholarshipsRenewableLabel: {
    id: 'scholarships.merit-scholarships.renewable-label',
    defaultMessage: 'Renewable',
  },
  meritScholarshipsOneTimeLabel: {
    id: 'scholarships.merit-scholarships.one-time-label',
    defaultMessage: 'One-time',
  },
  meritScholarshipsAudienceLabel: {
    id: 'scholarships.merit-scholarships.audience-label',
    defaultMessage: 'Audience',
  },
  meritScholarshipsAllStudentsLabel: {
    id: 'scholarships.merit-scholarships.all-students-label',
    defaultMessage: 'All students',
  },
  meritScholarshipsInStateStudentsLabel: {
    id: 'scholarships.merit-scholarships.in-state-students-label',
    defaultMessage: 'In-state students',
  },
  meritScholarshipsOutOfStateStudentsLabel: {
    id: 'scholarships.merit-scholarships.out-of-state-students-label',
    defaultMessage: 'Out-of-state students',
  },
  meritScholarshipsCustomStudentsLabel: {
    id: 'scholarships.merit-scholarships.custom-students-label',
    defaultMessage: 'Students in custom states',
  },
  meritScholarshipsRequirementsLabel: {
    id: 'scholarships.merit-scholarships.requirements-label',
    defaultMessage: 'Requirements',
  },
  meritScholarshipsRequirementsTextLabel: {
    id: 'scholarships.merit-scholarships.requirements-text-label',
    defaultMessage: 'Scholarships must have at least one requirement.',
  },
  meritScholarshipsGPALabel: {
    id: 'scholarships.merit-scholarships.requirements-gpa-label',
    defaultMessage: 'GPA',
  },
  meritScholarshipsGPAScaleLabel: {
    id: 'scholarships.merit-scholarships.requirements-gpa-scale-label',
    defaultMessage: '(4.0 scale)',
  },
  meritScholarshipsClassRankLabel: {
    id: 'scholarships.merit-scholarships.requirements-class-rank-label',
    defaultMessage: 'Class Rank',
  },
  meritScholarshipsClassRankScaleLabel: {
    id: 'scholarships.merit-scholarships.requirements-class-rank-scale-label',
    defaultMessage: '(Top %)',
  },
  meritScholarshipsSATLabel: {
    id: 'scholarships.merit-scholarships.requirements-sat-label',
    defaultMessage: 'SAT',
  },
  meritScholarshipsSATScaleLabel: {
    id: 'scholarships.merit-scholarships.requirements-sat-scale-label',
    defaultMessage: '(1600 scale)',
  },
  meritScholarshipsACTLabel: {
    id: 'scholarships.merit-scholarships.requirements-act-label',
    defaultMessage: 'Composite ACT',
  },
  meritScholarshipsSummaryMessagePrefix: {
    id: 'scholarships.merit-scholarships.summary-message',
    defaultMessage: 'This scholarship is for high school students with ',
  },
  meritScholarshipsInvalidUrl: {
    id: 'scholarships.merit-scholarships.invalid-url',
    defaultMessage: 'URL provided is not in a valid format',
  },
  addNewScholarship: {
    id: 'scholarships.merit-scholarships.add-new-scholarship',
    defaultMessage: 'ADD NEW SCHOLARSHIP',
  },
  cancelScholarship: {
    id: 'scholarships.merit-scholarships.cancel-scholarship',
    defaultMessage: 'Cancel',
  },
  cancelHeader: {
    id: 'scholarships.merit-scholarships.cancel-header',
    defaultMessage: 'Are you sure you want to cancel this scholarship?',
  },
  cancel: {
    id: 'scholarships.merit-scholarships.cancel',
    defaultMessage: 'Any changes you\'ve made will not be saved.',
  },
  deleteHeader: {
    id: 'scholarships.merit-scholarships.delete-header',
    defaultMessage: 'Are you sure that you want to delete this scholarship?',
  },
  delete: {
    id: 'scholarships.merit-scholarships.delete',
    defaultMessage: 'This will permanently delete the scholarship and it will no longer match with Naviance students.',
  },
  saveFailureHeader: {
    id: 'scholarships.merit-scholarships.save-failure-header',
    defaultMessage: 'Save failed for {scholarshipName}',
  },
  saveFailure: {
    id: 'scholarships.merit-scholarships.save-failure',
    defaultMessage: 'It looks like there were connectivity issues.',
  },
  invalidValue: {
    id: 'scholarships.merit-scholarships.invalid-value',
    defaultMessage: 'Enter a valid {scoreType} value between {minAllowed} and {maxAllowed}',
  },
  invalidRange: {
    id: 'scholarships.merit-scholarships.invalid-range',
    defaultMessage: 'Minimum {scoreType} must be less than maximum {scoreType}',
  },
  meritScholarshipsRequiredField: {
    id: 'scholarships.merit-scholarships.required-field',
    defaultMessage: 'Required field',
  },
  atLeast1Requirement: {
    id: 'scholarships.merit-scholarships.required-field.at-least-one-required',
    defaultMessage: 'At least one of the scholarship requirements is required',
  },
  modalSave: {
    id: 'scholarships.merit-scholarships.modal-save',
    defaultMessage: 'You have unsaved changes, would you like to save them?',
  },
  unsavedHeader: {
    id: 'scholarships.merit-scholarships.unsaved-header',
    defaultMessage: 'You have unsaved changes',
  },
  additionalInfoPlainText: {
    id: 'scholarships.merit-scholarships.additional-info-plain-text',
    defaultMessage: 'Plain text only (no HTML)',
  },
  duplicateName: {
    id: 'scholarships.merit-scholarships.duplicare-scholarship-name',
    defaultMessage: 'Scholarship name must be unique',
  },
});

export default messages;
